module.exports = __webpack_public_path__ + "img/SWP_Axe_2H_01 (1).57d91c73.png";